import { render } from "./save.vue?vue&type=template&id=da371afe"
import script from "./save.vue?vue&type=script&lang=js"
export * from "./save.vue?vue&type=script&lang=js"

import "./save.vue?vue&type=style&index=0&id=da371afe&lang=less"
script.render = render

export default script